import { useEffect, useState } from 'react';

const ACTIVITY_EVENTS = [
  'mousedown',
  'keydown',
  'touchstart',
  'scroll',
  'timer'
];

export const useLastUserActivity = (): number => {
  const [lastActivity, setLastActivity] = useState(Date.now());

  useEffect(() => {
    const updateLastActivity = () => {
      setLastActivity(Date.now());
    };
    for (const EVENT of ACTIVITY_EVENTS) {
      window.addEventListener(EVENT, updateLastActivity);
    }

    return () => {
      for (const EVENT of ACTIVITY_EVENTS) {
        window.removeEventListener(EVENT, updateLastActivity);
      }
    };
  }, []);

  return lastActivity;
};
